/**
 * Scrollbar styling for configuration list panels (metrics, KG columns, benchmarks).
 * Split view: slimmer thumb, transparent track, extra breathing room before the divider.
 */
export function listPanelScrollSx(splitDetailOpen: boolean) {
  const w = splitDetailOpen ? "3px" : "5px";
  return {
    scrollbarWidth: "thin" as const,
    scrollbarColor: splitDetailOpen
      ? "var(--chakra-colors-purple-100) transparent"
      : "var(--chakra-colors-gray-400) var(--chakra-colors-gray-100)",
    "::-webkit-scrollbar": {
      width: w,
    },
    "::-webkit-scrollbar-track": {
      background: splitDetailOpen ? "transparent" : "var(--chakra-colors-gray-100)",
      borderRadius: "999px",
      marginTop: splitDetailOpen ? "8px" : "4px",
      marginBottom: splitDetailOpen ? "8px" : "4px",
    },
    "::-webkit-scrollbar-thumb": {
      background: splitDetailOpen
        ? "var(--chakra-colors-purple-100)"
        : "var(--chakra-colors-gray-400)",
      borderRadius: "999px",
      border: splitDetailOpen ? "2px solid transparent" : "0",
      backgroundClip: splitDetailOpen ? "padding-box" : "border-box",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: splitDetailOpen
        ? "var(--chakra-colors-purple-100)"
        : "var(--chakra-colors-gray-400)",
    },
  };
}
